"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to list cities with finpro agencies for a state
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.cityList City list to display
 * @returns {React.ReactElement} list of agents
 */
function StateCityList(props) {
  var cityGlossary = (0, _lodash.groupBy)(props.cityList, x => x.cityName[0]);
  var glossaryKeys = (0, _lodash.keys)(cityGlossary);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled city-group-list"
  }, (0, _lodash.map)(glossaryKeys, (groupKey, groupIndex) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: groupIndex
    }, /*#__PURE__*/_react.default.createElement("h3", null, groupKey), /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled",
      id: "city-".concat(groupKey)
    }, (0, _lodash.map)(cityGlossary[groupKey], (city, cityIndex) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "h3",
        key: cityIndex
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "btn btn-inline",
        href: city.cityUrl
      }, city.cityName));
    })));
  })));
}
var _default = exports.default = StateCityList;